import { Navigate, useLocation, useParams } from 'react-router'

/**
 * `/work-items/:id` → `/kanbans/items/:id`
 * (SPEC-20261006-1351-item-abre-ao-lado-do-explorer).
 *
 * A edição do item passou a abrir ao lado do explorer de Trabalho. Notificação,
 * chat e e-mail continuam apontando para o endereço antigo — este desvio os
 * mantém valendo, e leva a query junto: o `?novo=1` de um item recém-criado não
 * pode se perder no caminho.
 */
export function RedirecionaItem() {
  const { id = '' } = useParams()
  const { search } = useLocation()
  return <Navigate to={`/kanbans/items/${id}${search}`} replace />
}
